import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

export default function CartIcon({ className = '', iconClassName = 'w-5 h-5' }) {
  const { count } = useCart();
  return (
    <Link
      to="/panier"
      data-testid="cart-link"
      aria-label={count > 0 ? `Panier, ${count} ${count > 1 ? 'articles' : 'article'}` : 'Panier'}
      className={`relative inline-flex items-center justify-center p-2 ${className}`}
    >
      <ShoppingCart className={iconClassName} />
      {count > 0 && (
        <span
          data-testid="cart-count"
          className="absolute -top-1 -right-1 min-w-[1.25rem] h-5 px-1 rounded-full
                     bg-amber-500 text-white text-xs font-bold flex items-center justify-center"
        >
          {count}
        </span>
      )}
    </Link>
  );
}
